<template>
    <div class="double-scroll">
        <div class="scroll-wrapper">
            <aside class="double-left" id="title-ul">
                <ul class="inner-ul">
                    <li v-for="(title, index) in titleItems"
                        :key="index"
                        class="double-l-li"
                        :class="{'active': titleActive == index}"
                        @click="scrollToRightUl(index)"
                        :id="`tactic-left-li-${index}`"
                    >
                        {{ title }}
                    </li>
                </ul>
            </aside>
            <aside class="double-right" id="right-ul">
                <div class="scroll-r-wrapper">
                    <ul class="right-inner-ul"
                        v-for="(tactic, ulindex) in tacticItems"
                        :key="ulindex"
                        :data-title="titleItems[ulindex]"
                        :id="`tactic-right-ul-${ulindex}`"
                    >
                        <li v-for="(tItem, tindex) in tactic"
                            :key="tindex"
                            class="double-r-li"
                            :class="{'active': rightSelectedRecord == `${ulindex}-${tindex}`}"
                            @click="selectRightUl(tItem, `${ulindex}-${tindex}`)"
                            :data-record="`${ulindex}-${tindex}`"
                        >
                            <span>{{ tItem.text }}</span>
                            <em>{{ tItem.reply ? '立即行动' : '就绪回复' }}</em>
                        </li>
                    </ul>
                </div>
            </aside>
        </div>
        <div class="submit-box">
            <div class="submit-men">
                <span v-for="(item, index) in infos"
                      :key="index"
                      v-show="item.status != 0"
                      :class="{'active': item.label == selectedMen[index]}"
                      @click="selectActman(item.label, index)"
                >
                    {{ item.label }}
                </span>
            </div>
            <div class="submit-btn">
                <button type="button" @click="sendTactic">发送指令</button>
            </div>
        </div>
    </div>
</template>

<script>
    // import { toRaw } from '@vue/reactivity';
    // https://www.jb51.net/article/273132.htm 使用toraw将proxy取出原始数据
    import { postSay } from "@/api/post";
    import { getSayHTML } from "@/common/fns";

    import BScroll from '@better-scroll/core';

    let bScrollLeft = null;
    let bScrollRight = null;

    const RIGHT_UL_ID = 'tactic-right-ul';
    const LEFT_LI_ID = 'tactic-left-li';


    export default {
        name: "double-scroll",
        emits: [ 'selectedTactic' ],
        props: {
            infos: {
                type: Array,
                default() {
                    return [];
                }
            },
            tacticData: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
                titleActive: 0,
                rightSelectedText: '',
                selectedMen: [],
                rightSelectedRecord: ''
            }
        },
        computed: {
            titleItems() {
                const arr = this.tacticData['titleArr'] ? this.tacticData['titleArr'] : [];
                return arr;
            },
            tacticItems() {
                const arr = this.tacticData['itemsArr'] ? this.tacticData['itemsArr'] : [];
                return arr;
            }
        },
        methods: {
            emitSelectedResult() {
                let menStr = this.selectedMen.join('');
                const menArr = menStr.split('');
                menStr = menArr.join('&');
                if (menStr != '') {
                    menStr = `${menStr}-`;
                }
                const title = this.titleItems[this.titleActive];
                const str = `${title}: ${menStr}${this.rightSelectedText}`;
                this.$emit('selectedTactic', str);
            },
            selectActman(label, index) {
                if (this.selectedMen[index]) {
                    this.selectedMen[index] = '';
                } else {
                    this.selectedMen[index] = label;
                }
                this.emitSelectedResult();
            },
            selectRightUl(tItem, record) {
                if (this.rightSelectedRecord == record) {
                    return;
                }
                const replyText = tItem.reply ? '立即行动' : '就绪回复';
                this.rightSelectedText = `${tItem.text}-${replyText}`;
                this.rightSelectedRecord = record;

                // 将标签取出ul索引的部分
                const ulIndex = parseInt(record.split('-')[0]);
                this.titleActive = ulIndex;
                const leftel = document.getElementById(`${LEFT_LI_ID}-${ulIndex}`);
                bScrollLeft.scrollToElement(leftel, 300, true, true);

                this.emitSelectedResult();
            },
            scrollToRightUl(index) {
                const ul = document.getElementById(`${RIGHT_UL_ID}-${index}`);
                bScrollRight.scrollToElement(ul, 300, true, true);
                this.titleActive = index;
            },
            scrollLeft() {
                this.$nextTick(() => {
                    if (bScrollLeft) {
                        bScrollLeft.refresh();
                    } else {
                        const wrapper = document.getElementById('title-ul');
                        bScrollLeft = new BScroll(wrapper, {
                            click: true
                        });
                    }
                });
            },
            scrollRight() {
                this.$nextTick(() => {
                    if (bScrollRight) {
                        bScrollRight.refresh();
                    } else {
                        const wrapper = document.getElementById('right-ul');
                        bScrollRight = new BScroll(wrapper, {
                            click: true
                        });
                    }
                })
            },
            // 发送战术消息
            async sendTactic() {
                const username = window.setting.userInfo.username;
                let content = '';
                if (this.rightSelectedText) {
                    // 将消息拼接成html
                    let menStr = this.selectedMen.join('');
                    const menArr = menStr.split('');
                    menStr = menArr.join('&');
                    const title = this.titleItems[this.titleActive];
                    content = getSayHTML.tactic({
                        title: title,
                        menStr: menStr,
                        rightSelectedText: this.rightSelectedText
                    });
                } else {
                    content = '';
                }

                const res = await postSay(username, content);
                console.log(res)
            }
        },
        watch: {
            titleItems(newval, oldval) {
                if (newval == oldval) {
                    return;
                }
                this.scrollLeft();
            },
            tacticItems(newval, oldval) {
                if (newval == oldval) {
                    return;
                }
                this.scrollRight();
            }
        }
    }
</script>

<style scoped>
    .scroll-wrapper {
        display: flex;
    }
    .right-inner-ul{
        padding: 10px 0;
    }
    .right-inner-ul:before{
        content: attr(data-title);
        line-height: 20px;
        height: 20px;
        border-left: 3px solid;
        color: #7b95d2;
        display: block;
        padding-left: 5px;
        margin-bottom: 5px;
    }

    .double-left {
        flex: 0 0 80px;
        border-right: 1px solid #161D2E;
        padding-bottom: 10px;
    }
    .double-right{
        flex: 1;
        padding: 0px 0px 0 10px;
    }

    .double-left,
    .double-right {
        height: 200px;
        overflow: hidden;
    }

    .double-l-li {
        color: #fff;
        line-height: 36px;
        text-align: center;
    }

    .double-l-li.active {
        background-color: #131825;
    }


    .double-r-li {
        padding: 10px 10px;
        color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .double-r-li.active{
        background-color: #131825;
    }
    .double-r-li em{
        font-size: 12px;
        color: #3F4E70;
        flex: 0 0 50px;
    }
    .double-r-li span{
        display: inline-block;
        flex: 1;
        padding-right: 10px;
    }
</style>
